import { Text, Flex, Icon, Tag, Stack, Skeleton } from "@chakra-ui/react";
import { HiMapPin } from "react-icons/hi2";

import { ReactElement } from "react";

import { Image } from "@/storybook-components";

export interface PinDetailsProps {
  pinType?: string;
  pinAddress?: string;
  isLoaded?: boolean;
  pinColor?: string;
  pinImageSrc?: string;
  isAddressVisible?: boolean;
  pinIcon?: ReactElement;
}

export const PinDetails = (props: PinDetailsProps) => {
  const {
    pinType,
    pinAddress,
    isLoaded,
    pinColor,
    pinImageSrc,
    pinIcon,
    isAddressVisible
  } = props;

  const pinStructure = () => {
    if (pinImageSrc) {
      return <Image src={pinImageSrc} height={6} width={6} alt={pinType} />;
    } else if (pinIcon) {
      return pinIcon || null;
    } else {
      return (
        <Icon
          justifySelf="flex-start"
          aria-label="See menu"
          minWidth={6}
          as={HiMapPin}
          width={6}
          height={6}
          color={pinColor || "purple.600"}
          data-testid="card-mapPinIcon"
        />
      );
    }
  };
  return (
    <Skeleton isLoaded={isLoaded}>
      <Stack width="full">
        <Flex gap={1}>
          {pinStructure()}
          {pinType && (
            <Tag
              colorScheme="purple"
              variant="solid"
              data-testid="card-pinTypeTag"
              style={{
                backgroundColor: pinColor,
                ...(pinIcon ? { height: 22, marginTop: 5 } : {})
              }}
            >
              {pinType}
            </Tag>
          )}
        </Flex>
        {isAddressVisible && (
          <Text
            fontSize="xs"
            fontWeight={500}
            data-test-id="card-pinAddressText"
          >
            {pinAddress}
          </Text>
        )}
      </Stack>
    </Skeleton>
  );
};
